import React from 'react';

const ReportsAnalytics = () => {
  return (
    <>
    
      {/* Page Header */}
      <div className="page-header">
        <div className="title-section">
          <div className="page-title">Reports & Analytics</div>
          <div className="page-subtitle">View and generate reports for your health services</div>
        </div>
        <div className="action-buttons">
          <button className="outline-button">
            <span className="material-icons button-icon">file_download</span>
            Export Data
          </button>
          <button className="primary-button">
            <span className="material-icons button-icon">add</span>
            Generate Report
          </button>
        </div>
      </div>
      
      {/* Filters Section */}
      <div className="section-card">
        <div className="section-title">
          <span className="material-icons section-icon">filter_alt</span>
          Filters
        </div>
        
        <div className="filters-container">
          <div className="filter-field">
            <label>Village:</label>
            <select>
              <option value="all">All Villages</option>
              <option value="rampur">Rampur</option>
              <option value="ganeshpur">Ganeshpur</option>
              <option value="shivpura">Shivpura</option>
            </select>
          </div>
          
          <div className="filter-field">
            <label>Service:</label>
            <select>
              <option value="all">All Services</option>
              <option value="home_visits">Home Visits</option>
              <option value="immunization">Immunization</option>
              <option value="anc">ANC</option>
              <option value="referrals">Referrals</option>
            </select>
          </div>
          
          <div className="filter-field">
            <label>Period:</label>
            <select>
              <option value="last_30_days">Last 30 Days</option>
              <option value="last_3_months">Last 3 Months</option>
              <option value="last_6_months">Last 6 Months</option>
              <option value="last_year">Last Year</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>
          
          <div className="date-field">
            <span className="material-icons" style={{ marginRight: '8px', color: '#666' }}>calendar_today</span>
            <input type="date" placeholder="Start Date" />
          </div>
          
          <div className="date-field">
            <span className="material-icons" style={{ marginRight: '8px', color: '#666' }}>calendar_today</span>
            <input type="date" placeholder="End Date" />
          </div>
          
          <button className="primary-button">
            <span className="material-icons button-icon">search</span>
            Apply Filters
          </button>
        </div>
      </div>
      
      {/* Main Content Section */}
      <div className="section-card">
        <div className="tab-container">
          <div className="tabs">
            <div className="tab active">Performance Dashboard</div>
            <div className="tab">Saved Reports</div>
            <div className="tab">Data Tables</div>
          </div>
          
          {/* Metrics Cards */}
          <div className="metrics-container">
            <div className="metric-card">
              <div className="metric-icon">
                <span className="material-icons">home</span>
              </div>
              <div className="metric-value">127</div>
              <div className="metric-label">Home Visits</div>
              <div className="comparison positive">↑ 12% vs last period</div>
            </div>
            
            <div className="metric-card">
              <div className="metric-icon blue">
                <span className="material-icons">child_care</span>
              </div>
              <div className="metric-value">85</div>
              <div className="metric-label">Immunizations</div>
              <div className="comparison positive">↑ 8% vs last period</div>
            </div>
            
            <div className="metric-card">
              <div className="metric-icon purple">
                <span className="material-icons">pregnant_woman</span>
              </div>
              <div className="metric-value">42</div>
              <div className="metric-label">ANC Visits</div>
              <div className="comparison positive">↑ 5% vs last period</div>
            </div>
            
            <div className="metric-card">
              <div className="metric-icon orange">
                <span className="material-icons">local_hospital</span>
              </div>
              <div className="metric-value">18</div>
              <div className="metric-label">Referrals</div>
              <div className="comparison negative">↓ 3% vs last period</div>
            </div>
            
            <div className="metric-card">
              <div className="metric-icon red">
                <span className="material-icons">event</span>
              </div>
              <div className="metric-value">6</div>
              <div className="metric-label">VHND Sessions</div>
              <div className="comparison">~ Same as last period</div>
            </div>
          </div>
          
          {/* Charts Row */}
          <div className="flex-row">
            <div className="flex-column">
              <div className="section-title">
                <span className="material-icons section-icon">trending_up</span>
                Service Delivery Trends
              </div>
              
              <div className="chart-container">
                <div className="chart-placeholder">[Service Delivery Trend Chart]</div>
              </div>
            </div>
            
            <div className="flex-column">
              <div className="section-title">
                <span className="material-icons section-icon">pie_chart</span>
                Beneficiary Distribution
              </div>
              
              <div className="chart-container">
                <div className="chart-placeholder">[Beneficiary Distribution Chart]</div>
              </div>
            </div>
          </div>
          
          {/* Immunization Coverage Summary */}
          <div className="summary-card">
            <div className="summary-title">Immunization Coverage</div>
            <div className="summary-content">
              <div className="summary-metrics">
                <div className="summary-metric">
                  <div className="summary-metric-label">Target Children</div>
                  <div className="summary-metric-value">120</div>
                </div>
                <div className="summary-metric">
                  <div className="summary-metric-label">Fully Immunized</div>
                  <div className="summary-metric-value">84</div>
                </div>
                <div className="summary-metric">
                  <div className="summary-metric-label">Partially Immunized</div>
                  <div className="summary-metric-value">24</div>
                </div>
                <div className="summary-metric">
                  <div className="summary-metric-label">Not Immunized</div>
                  <div className="summary-metric-value">12</div>
                </div>
              </div>
              <div className="summary-chart">
                <div className="donut-chart"></div>
                <div className="donut-hole"></div>
                <div className="summary-chart-value">70%</div>
              </div>
            </div>
          </div>
          
          {/* ANC Coverage Summary */}
          <div className="summary-card">
            <div className="summary-title">ANC Coverage</div>
            <div className="summary-content">
              <div className="summary-metrics">
                <div className="summary-metric">
                  <div className="summary-metric-label">Pregnant Women</div>
                  <div className="summary-metric-value">48</div>
                </div>
                <div className="summary-metric">
                  <div className="summary-metric-label">4+ ANC Visits</div>
                  <div className="summary-metric-value">36</div>
                </div>
                <div className="summary-metric">
                  <div className="summary-metric-label">Partial ANC</div>
                  <div className="summary-metric-value">10</div>
                </div>
                <div className="summary-metric">
                  <div className="summary-metric-label">No ANC</div>
                  <div className="summary-metric-value">2</div>
                </div>
              </div>
              <div className="summary-chart">
                <div 
                  className="donut-chart" 
                  style={{ 
                    background: `conic-gradient(
                      #4CAF50 0% 75%,
                      #f0f0f0 75% 100%
                    )` 
                  }}
                ></div>
                <div className="donut-hole"></div>
                <div className="summary-chart-value">75%</div>
              </div>
            </div>
          </div>
          
          {/* Village Performance Table */}
          <div className="section-title">
            <span className="material-icons section-icon">table_chart</span>
            Service Delivery by Village
          </div>
          
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Village</th>
                  <th>Home Visits</th>
                  <th>Immunization</th>
                  <th>ANC</th>
                  <th>Referrals</th>
                  <th>Coverage</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Rampur</td>
                  <td>48</td>
                  <td>32</td>
                  <td>18</td>
                  <td>7</td>
                  <td><span className="status-tag status-high">85%</span></td>
                </tr>
                <tr>
                  <td>Ganeshpur</td>
                  <td>36</td>
                  <td>28</td>
                  <td>12</td>
                  <td>5</td>
                  <td><span className="status-tag status-high">78%</span></td>
                </tr>
                <tr>
                  <td>Shivpura</td>
                  <td>24</td>
                  <td>15</td>
                  <td>8</td>
                  <td>4</td>
                  <td><span className="status-tag status-medium">65%</span></td>
                </tr>
                <tr>
                  <td>Krishna Nagar</td>
                  <td>19</td>
                  <td>10</td>
                  <td>4</td>
                  <td>2</td>
                  <td><span className="status-tag status-low">52%</span></td>
                </tr>
              </tbody>
            </table>
          </div>
          
          {/* Pagination */}
          <div className="pagination">
            <div className="pagination-item">
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="pagination-item active">1</div>
            <div className="pagination-item">2</div>
            <div className="pagination-item">3</div>
            <div className="pagination-item">
              <span className="material-icons">chevron_right</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Recently Viewed Reports */}
      <div className="section-card">
        <div className="section-title">
          <span className="material-icons section-icon">description</span>
          Recently Viewed Reports
        </div>
        
        <div className="grid-container">
          <div className="report-card">
            <div className="report-icon icon-blue">
              <span className="material-icons">description</span>
            </div>
            <div className="report-title">Monthly Performance Report</div>
            <div className="report-description">Summary of all health service activities for March 2023</div>
            <div className="report-meta">
              <div>Last viewed: Today</div>
              <div>PDF</div>
            </div>
          </div>
          
          <div className="report-card">
            <div className="report-icon icon-green">
              <span className="material-icons">child_care</span>
            </div>
            <div className="report-title">Immunization Coverage</div>
            <div className="report-description">Analysis of immunization services and coverage rates</div>
            <div className="report-meta">
              <div>Last viewed: Yesterday</div>
              <div>Excel</div>
            </div>
          </div>
          
          <div className="report-card">
            <div className="report-icon icon-purple">
              <span className="material-icons">pregnant_woman</span>
            </div>
            <div className="report-title">ANC Monitoring Report</div>
            <div className="report-description">Tracking of ANC visits and maternal health indicators</div>
            <div className="report-meta">
              <div>Last viewed: 3 days ago</div>
              <div>PDF</div>
            </div>
          </div>
          
          <div className="report-card">
            <div className="report-icon icon-teal">
              <span className="material-icons">insights</span>
            </div>
            <div className="report-title">Quarterly Performance</div>
            <div className="report-description">Comprehensive analysis of Q1 2023 health activities</div>
            <div className="report-meta">
              <div>Last viewed: 1 week ago</div>
              <div>PDF</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportsAnalytics; 